import React, { useEffect } from "react";
import { Confetti } from "@phosphor-icons/react";

/**
 * v1.25.46 — Screen-wide confetti burst (no card, no dismiss button).
 * Fires for ~2.5 s over the whole viewport then unmounts itself. Use for
 * "big win" moments like payout completed, credit-limit reset, monthly close.
 */
export default function ConfettiBurst({ open, onClose, pieces = 60 }) {
    useEffect(() => {
        if (!open) return;
        const t = setTimeout(onClose, 2600);
        return () => clearTimeout(t);
    }, [open, onClose]);

    if (!open) return null;
    const colors = ["text-amber-400", "text-emerald-400", "text-rose-400", "text-sky-400", "text-fuchsia-400", "text-indigo-400"];
    return (
        <div className="pointer-events-none fixed inset-0 z-[110] overflow-hidden">
            {Array.from({ length: pieces }).map((_, i) => {
                const left = (i * 100 / pieces + (i * 13) % 7) % 100;
                const delay = (i % 9) * 60;
                const dur = 1500 + (i * 41) % 900;
                const rot = (i * 37) % 360;
                const size = 14 + (i * 5) % 12;
                return (
                    <Confetti
                        key={i}
                        size={size}
                        weight="fill"
                        className={`absolute ${colors[i % colors.length]}`}
                        style={{
                            left: `${left}%`,
                            top: "-6%",
                            animation: `burst-fall ${dur}ms ease-in ${delay}ms forwards`,
                            transform: `rotate(${rot}deg)`,
                        }}
                    />
                );
            })}
            <style>{`
                @keyframes burst-fall {
                    0%   { transform: translateY(-8vh) rotate(0deg); opacity: 0; }
                    10%  { opacity: 1; }
                    100% { transform: translateY(112vh) rotate(720deg); opacity: 0.25; }
                }
            `}</style>
        </div>
    );
}
